import React, { Component } from "react";
import PropTypes from "prop-types";

import { isDefined, noop, mapObject, head } from "../utils";
import { getMorePropsForChart, getSelected } from "./utils";

import GenericComponent, { getMouseCanvas } from "../GenericComponent";

class DrawingObjectSelector extends Component {
  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
    this.handleDoubleClick = this.handleDoubleClick.bind(this);
    this.handleContextMenu = this.handleContextMenu.bind(this);
    this.getInteraction = this.getInteraction.bind(this);
  }
  handleDoubleClick(moreProps, e) {
    e.preventDefault();
    const { onDoubleClick } = this.props;
    const { enabled } = this.props;
    if (!enabled) return;

    const interactives = this.getInteraction(moreProps);
    const allSelected = getSelected(interactives);

    // console.log(selected, interactives)
    if (allSelected.length > 0) {
      const selected = head(allSelected);
      const selectedObject = head(selected.objects);

      // Find the index of the selected object in the original array
      const interactive = interactives.find(
        (i) => i.type === selected.type && i.chartId === selected.chartId,
      );
      const index = interactive
        ? interactive.objects.findIndex((obj) => obj === selectedObject)
        : 0;

      const item = {
        type: selected.type,
        chartId: selected.chartId,
        object: selectedObject,
        index: index,
      };
      const morePropsForChart = getMorePropsForChart(
        moreProps,
        selected.chartId,
      );
      onDoubleClick(item, morePropsForChart);
    }
  }
  handleContextMenu(moreProps, e) {
    e.preventDefault();
    const { onContextMenu } = this.props;
    const { enabled } = this.props;
    if (!enabled) return;

    const interactives = this.getInteraction(moreProps);
    const allSelected = getSelected(interactives);

    // console.log(selected, interactives)
    if (allSelected.length > 0) {
      const selected = head(allSelected);
      const selectedObject = head(selected.objects);

      // Find the index of the selected object in the original array
      const interactive = interactives.find(
        (i) => i.type === selected.type && i.chartId === selected.chartId,
      );
      const index = interactive
        ? interactive.objects.findIndex((obj) => obj === selectedObject)
        : 0;

      const item = {
        type: selected.type,
        chartId: selected.chartId,
        object: selectedObject,
        index: index,
      };
      const morePropsForChart = getMorePropsForChart(
        moreProps,
        selected.chartId,
      );
      onContextMenu(item, morePropsForChart, e);
    }
  }
  handleClick(moreProps, e) {
    e.preventDefault();
    const { onSelect } = this.props;
    const { enabled } = this.props;
    if (!enabled) return;

    const interactives = this.getInteraction(moreProps);

    onSelect(interactives, moreProps);
  }
  getInteraction(moreProps) {
    const { getInteractiveNodes, drawingObjectMap } = this.props;
    const interactiveNodes = getInteractiveNodes();

    const interactives = mapObject(interactiveNodes, (each) => {
      const key = drawingObjectMap[each.type];

      const valueArray = isDefined(key) ? each.node.props[key] : undefined;

      const valuePresent =
        isDefined(valueArray) &&
        Array.isArray(valueArray) &&
        valueArray.length > 0;
      if (valuePresent) {
        // console.log("Value present for ", each.type, each.chartId);
        const morePropsForChart = getMorePropsForChart(moreProps, each.chartId);

        // Additional safety check in case chartConfig is null
        if (!morePropsForChart || !morePropsForChart.chartConfig) {
          return {
            type: each.type,
            chartId: each.chartId,
            objects: [],
          };
        }

        const objects = each.node.getSelectionState(morePropsForChart);

        return {
          type: each.type,
          chartId: each.chartId,
          objects,
        };
      }
      return {
        type: each.type,
        chartId: each.chartId,
        objects: [],
      };
    });

    return interactives;
  }

  render() {
    return (
      <GenericComponent
        svgDraw={noop}
        canvasToDraw={getMouseCanvas}
        canvasDraw={noop}
        onMouseDown={this.handleClick}
        onDoubleClick={this.handleDoubleClick}
        onContextMenu={this.handleContextMenu}
        drawOn={["mousemove", "pan", "drag", "xAxisZoom"]}
      />
    );
  }
}

DrawingObjectSelector.propTypes = {
  getInteractiveNodes: PropTypes.func.isRequired,
  onSelect: PropTypes.func.isRequired,
  onDoubleClick: PropTypes.func.isRequired,
  onContextMenu: PropTypes.func.isRequired,
  drawingObjectMap: PropTypes.object.isRequired,
  enabled: PropTypes.bool.isRequired,
};

DrawingObjectSelector.defaultProps = {
  enabled: true,
  onDoubleClick: noop,
  onContextMenu: noop,
};

export default DrawingObjectSelector;
